<template>
  <div id="about">
    <ks-header :header-title="$t('navbar.aboutUs')" />

    <div id="main-container" v-scroll-lock="true">
      <div id="main-content">
        <b-container class="p-4">
          <b-container class="about-logo">
            <img :alt="$t('navbar.logo')" id="logo" src="@/assets/images/logos/kf_logo.png">
          </b-container>
          <hr>
          <b-row class="social-media">
            <a href="https://www.facebook.com/kultursphaere" target="_blank">
              <b-col class="social">
                <img :alt="$t('common.facebook')" src="@/assets/images/icons/social-media/facebook.svg">
              </b-col>
            </a>
            <a href="https://twitter.com/kultursphaere" target="_blank">
              <b-col class="social">
                <img :alt="$t('common.twitter')" src="@/assets/images/icons/social-media/twitter.svg">
              </b-col>
            </a>
            <a href="http://www.instagram.com/kultursphaere" target="_blank">
              <b-col class="social">
                <img :alt="$t('common.instagram')" src="@/assets/images/icons/social-media/instagram.svg">
              </b-col>
            </a>
          </b-row>
          <p class="mt-4">
            {{ $t("about.description") }}
          </p>
          <section id="partners" class="py-3">
            <b-row class="align-items-center">
              <b-col
                cols="6" sm="3"
                v-for="partner in partners"
                :key="partner.name"
                class="h-100 my-4"
              >
                <img
                  :alt="partner.name"
                  :src="partner.src"
                  class="w-100"
                >
              </b-col>
            </b-row>
          </section>
          <h2 class="mt-4">{{ $t("about.leadingLegal") }}</h2>
          <p>
            {{ $t("about.address0") }}<br>
            {{ $t("about.address1") }}<br>
            {{ $t("about.address2") }}<br>
            {{ $t("about.address3") }}
          </p>
          <h2 class="mt-4">{{ $t("common.contact") }}</h2>
          <p>
            <span class="contact">
              <icon-base
                color="#003064"
                :title="$t('common.website')"
                class="mr-2"
                role="img"
              >
                <icon-globe />
              </icon-base>
              <a :href="'https://' + $t('common.www')" target="_blank">
                {{ $t("common.www") }}
              </a>
            </span>
            <span class="contact">
              <icon-base
                color="#003064"
                title="Email-Adresse"
                class="mr-2"
                role="img"
              >
                <icon-mail />
              </icon-base>
              <a :href="'mailto:' + $t('common.mailto')">
                {{ $t("common.mailto") }}
              </a>
            </span>
          </p>
          <h2 class="mt-4">{{ $t("about.privacy") }}</h2>
          <p>
            {{ $t("about.noThirdParties") }}
          </p>
          <h2 class="mt-4">{{ $t("about.matomo") }}</h2>
          <b-form-checkbox
            v-model="analyticsConsent"
            name="analytics-checkbox"
            @change="changeAnalyticsConsent()"
            class="mb-3"
          >
            <span>{{ $t("about.matomoConsent") }}</span>
          </b-form-checkbox>
          <p>
            {{ $t("about.matomoDescription") }}
          </p>
          <p>
            {{ $t("about.matomoDescription2") }}
          </p>
          <h2 class="mt-4">{{ $t("about.legalNotice") }}</h2>
          <p>
            {{ $t("about.legalNoticeDescription") }}
          </p>
          <ul>
            <li>{{ $t("about.legalNoticePoint1") }}</li>
            <li>{{ $t("about.legalNoticePoint2") }}</li>
            <li>{{ $t("about.legalNoticePoint3") }}</li>
            <li>{{ $t("about.legalNoticePoint4") }}</li>
            <li>{{ $t("about.legalNoticePoint5") }}</li>
            <li>{{ $t("about.legalNoticePoint6") }}</li>
            <li>{{ $t("about.legalNoticePoint7") }}</li>
          </ul>
          <span>{{ $t("about.legalNoticeProducedBy") }}</span>
          <h2 class="mt-4">{{ $t("about.positionRelatedData") }}</h2>
          <p>
            {{ $t("about.positionRelatedDataProcessing") }}
          </p>
        </b-container>
      </div>
    </div>
  </div>
</template>

<script>
import KsHeader from '@/components/layout/Header.vue'
import ScrollPosition from '@/mixins/scrollposition'

export default {
  name: 'About',
  data() {
    return {
      analyticsConsent: false,
      partners: [
        {
          name: 'Fachhochschule Kiel',
          src: require('@/assets/images/logos/logo_fh-kiel.png')
        },
        {
          name: 'Schleswig-Holsteinische Landesbibliothek',
          src: require('@/assets/images/logos/logo_shlb.png')
        },
        {
          name: 'digiCULT',
          src: require('@/assets/images/logos/logo_digicult.png')
        },
        {
          name: 'Dataport',
          src: require('@/assets/images/logos/logo_dataport.png')
        }
      ]
    }
  },
  mounted() {
    var checkConsentCookie = this.getCookie('CookieConsent')
    if (checkConsentCookie === 'false') {
      this.analyticsConsent = false
    } else {
      this.analyticsConsent = true
    }
  },
  methods: {
    changeAnalyticsConsent() {
      // Change The Cookie Consent
      this.analyticsConsent = !this.analyticsConsent
      if (this.analyticsConsent) {
        // changed to true
        var expireDate = new Date()
        expireDate.setTime(expireDate.getTime() + (50 * 365 * 24 * 60 * 60 * 1000))
        document.cookie = 'CookieConsent=true; expires=' + expireDate.toUTCString() + '; path=/;'

        // Reload Site
        // Matomo is working on this issue here: https://github.com/matomo-org/matomo/issues/13056
        window.location.reload(true)
      } else {
        // changed to false

        // Create Deny Cookie
        document.cookie = 'CookieConsent=false; expires=; path=/;'

        // Reload Site
        // Matomo is working on this issue here: https://github.com/matomo-org/matomo/issues/13056
        window.location.reload(true)
      }
    },
    getCookie(cname) {
      var name = cname + '='
      var ca = document.cookie.split(';')
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i]
        while (c.charAt(0) === ' ') {
          c = c.substring(1)
        }
        if (c.indexOf(name) === 0) {
          return c.substring(name.length, c.length)
        }
      }
      return ''
    }
  },
  components: {
    KsHeader
  },
  mixins: [ScrollPosition]
}
</script>

<style scoped>
.logo {
  width: auto;
  height: 40px;
  object-fit: contain;
}

.about-logo {
  display: flex;
  justify-content: center;
  align-content: center;
}

.social-media {
  display: flex;
  justify-content: center;
  padding: 2% 10% 2% 10%;
}

.social {
  display: flex;
  flex-direction: column;
  cursor: pointer;
}

#logo {
  max-height: 75px;
}

.empty-nav-item{
width: 5vw;
}
.contact {
  display: flex;
  align-items: center;
}
</style>
